// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Determines the correct article (a/an) to use before a word.
 * Uses "an" if the word starts with a vowel sound, "a" otherwise.
 *
 * @param word - The word to check
 * @returns "a" or "an"
 */
function getArticle(word: string): string {
  if (!word) return 'a';
  return /^[aeiouAEIOU]/.test(word) ? 'an' : 'a';
}

/**
 * Gets the correct article for a field type.
 * Convenience function specifically for field types.
 *
 * @param fieldType - The field type string
 * @returns "a" or "an"
 */
export function getFieldTypeArticle(fieldType: string): string {
  return getArticle(fieldType);
}
